import React from "react";
import "./SecondSpinner.css";
const SecondSpinner = () => (
  <div className="second_spinner_container">
    <div className="second_loader"></div>
  </div>
);

export default SecondSpinner;
